import { createAsyncThunk } from '@reduxjs/toolkit';

import { TNotesResponseScheme } from '../../../packages/monolith-python/notes';
import { updateOfferNoteApi } from '../../services';
import { addNotification, noteActions } from '../../slices';
import { ENotificationType } from '../../types/notifications';
import { IOffer } from '../../types/offers';
import { EThunkRejectCause } from '../../types/redux/thunkRejectCause';
import { requestAuthentication } from '../auth';
import { IThunkApi } from 'shared/types/redux';

export enum EUpdateNoteAction {
  Save = 'save',
  Delete = 'delete',
}

type IUpdateOfferNoteParams = {
  offer: IOffer | undefined;
  action: EUpdateNoteAction.Save | EUpdateNoteAction.Delete;
  text: string | undefined;
};

export type IUpdateOfferNotePayload = {
  offerId: number;
  text: string | undefined;
};

export const updateOfferNote = createAsyncThunk<IUpdateOfferNotePayload | void, IUpdateOfferNoteParams, IThunkApi>(
  'notes/updateOfferNote',
  async ({ offer, action, text }, _thunkApi) => {
    const { dispatch, fulfillWithValue, rejectWithValue, extra: context, getState } = _thunkApi;
    const { user, page } = getState();
    const { httpApi } = context;

    if (!offer) {
      return;
    }

    const { dealType, offerType, id } = offer;

    const errorText = action === EUpdateNoteAction.Save ? 'Не удалось сохранить заметку' : 'Не удалось удалить заметку';
    const successText = action === EUpdateNoteAction.Save ? 'Заметка сохранена' : 'Заметка удалена';

    if (!offerType || !dealType || !id) {
      dispatch(addNotification({ type: ENotificationType.Error, text: errorText }));

      return;
    }

    const params = {
      oid: id,
      text,
      action,
      csrf_token: '', // всегда ''
      dealType,
      offerType,
      httpApi,
      subdomain: page.subdomain,
    };

    if (!user.isAuthenticated) {
      dispatch(requestAuthentication());
    }

    try {
      const response: TNotesResponseScheme = await updateOfferNoteApi(params);

      if (response?.statusCode === 200) {
        dispatch(noteActions.reset());
        dispatch(addNotification({ type: ENotificationType.Success, text: successText }));

        return fulfillWithValue({ offerId: id, text });
      }
      dispatch(addNotification({ type: ENotificationType.Error, text: errorText }));

      return rejectWithValue(EThunkRejectCause.Error);
    } catch {
      dispatch(addNotification({ type: ENotificationType.Error, text: errorText }));

      return rejectWithValue(EThunkRejectCause.Error);
    }
  },
);
